import { ConfigurationKey } from 'src/app/core/models/configuration-key';
import { InstanceService } from '@commonspirit/ngx-instance';
import { SelectedGeolocation, SessionConstants } from '../../shared/models/v2/search';

export interface MedicalGroup {
  label: string;
  value: string;
  url: string;
}

export interface Item {
  label: string;
  value: string;
  count: number;
}

export interface FilterItem {
  item: Item[];
}

export interface Filter {
  ServicesAvailable: FilterItem[];
  acceptsNewPatients: FilterItem[];
  locationType: FilterItem[];
}

export interface FacetSummary {
  name: string;
  count?: number;
  selected: boolean;
  label: string;
}

export class FiltersModel {
  constructor(public service: InstanceService) {
    // Currently, we are storing the 0/20/40/60/80/100 in the FiltersModel which corresponds to the values in the slider control.
    //let defaultSearchDistance = this.service.getConfiguration(this.searchRadiusFilterKey)?.value as { defaultDistance: number }) ?? undefined;
    this.locationSearchRadius = 10;
    this.searchRadius = FiltersModelPartialHelper.getRadiusKeyForDistance(this.locationSearchRadius);
    //  this.medicalGroupList = FiltersModelPartialHelper.getMedGroups(configurationService.getMedGroupCodes());
  }

  searchRadiusFilterKey = ConfigurationKey.SearchRadiusFilter;

  onlineSchedulingToggle = false;
  onlineSchedulingApplied = false;
  onlineSchedulingLocationsCount = 0;

  newPatientsToggle = false;
  newPatientsApplied = false;
  newPatientsLocationsCount = 0;

  locationTypeFilterDisplayText = 'Location type';
  locationTypeToggle = false;
  locationTypeApplied = false;
  selectedLocationTypes: FacetSummary[] = [];
  providerLocationTypes: FacetSummary[] = [];
  availableLocationTypes: FacetSummary[] = [];
  locationTypesCount = 0;

  servicesAvailableFilterDisplayText = 'Services available';
  servicesAvailableToggle = false;
  servicesAvailableApplied = false;
  selectedSpecialties: FacetSummary[] = [];
  providerSpecialties: FacetSummary[] = [];
  availableSpecialties: FacetSummary[] = [];
  servicesAvailableCount = 0;

  openNowToggle = false;
  openNowApplied = false;
  openNowLocationsCount = 0;

  searchRadius: number | undefined;
  locationSearchRadius: number | undefined;

  pageNumber!: number;
}

export class FiltersModelPartialHelper {
  static radiusValueMapping = [
    {
      key: 0,
      value: 5
    },
    {
      key: 25,
      value: 10
    },
    {
      key: 50,
      value: 25
    },
    {
      key: 75,
      value: 50
    },
    {
      key: 100,
      value: 100
    }
  ];

  public static getRadiusKeyForDistance(distance: number | undefined): number | undefined {
    return FiltersModelPartialHelper.radiusValueMapping.find((m) => m.value === distance)?.key;
  }

  public static getDistanceForSearchRadiusKey(filtersModel: Partial<FiltersModel>): number | undefined {
    return FiltersModelPartialHelper.radiusValueMapping.find((m) => m.key === filtersModel.searchRadius)?.value;
  }

  public static SpecialityToggle(specialty: FacetSummary, filtersModel: Partial<FiltersModel>): void {
    if (!filtersModel.selectedSpecialties?.map((n) => n.name).includes(specialty.name)) {
      filtersModel.selectedSpecialties?.push(specialty);
    } else {
      const entryToRemove = filtersModel.selectedSpecialties.filter((s) => s.name === specialty.name)[0];
      filtersModel.selectedSpecialties.splice(filtersModel.selectedSpecialties.indexOf(entryToRemove), 1);
    }
  }

  public static LocationTypeToggle(locationType: FacetSummary, filtersModel: Partial<FiltersModel>): void {
    if (!filtersModel.selectedLocationTypes?.map((n) => n.name).includes(locationType.name)) {
      filtersModel.selectedLocationTypes?.push(locationType);
    } else {
      const entryToRemove = filtersModel.selectedLocationTypes.filter((s) => s.name === locationType.name)[0];
      filtersModel.selectedLocationTypes.splice(filtersModel.selectedLocationTypes.indexOf(entryToRemove), 1);
    }
  }

  public static setLocationTypes(locationTypes: FacetSummary[]): void {
    if (locationTypes.length > 0) {
      const typeArray: string[] = [];
      locationTypes.forEach((x) => {
        typeArray.push(x.name);
      });
      window.sessionStorage.setItem(SessionConstants.SelectedLocationTypesFilter, JSON.stringify(typeArray));
    }
  }

  public static setSpecialties(specialties: FacetSummary[]): void {
    if (specialties.length > 0) {
      const typeArray: string[] = [];
      specialties.forEach((x) => {
        typeArray.push(x.name);
      });
      window.sessionStorage.setItem(SessionConstants.SelectedSpecialtiesFilter, JSON.stringify(typeArray));
    }
  }

  public static toString(filtersModel: Partial<FiltersModel>): string {
    const result = Object.entries(filtersModel)
      .filter((x) => !!x && !!x[1])
      .map((x) => `${x[0]}=${JSON.stringify(x[1])}`)
      .join('&');
    return result;
  }

  public static isDesktopFiltersSelected(
    filtersModel: Partial<FiltersModel>,
    selectedGeolocation: SelectedGeolocation,
    defaultSearchDistance: number | undefined,
    showSearchRadiusFilter: boolean
  ): boolean {
    return (
      showSearchRadiusFilter && selectedGeolocation && filtersModel.searchRadius !== this.getRadiusKeyForDistance(defaultSearchDistance)
    );
  }
}
